<template>
     <div class="choiceComponent" id="choiceComponent" @keyup.down="keyDown" @keyup.up="keyUp" @keyup.right="keyRight" @keyup.left="keyLeft" @keyup.enter="confirm" v-clickoutside="handleClose">
            <el-input size="small" name="choiceDropInput" id="choiceInput" placeholder="请选择主要字段" @click.native="showChoiceBox" v-model="field" @change="changeFieldValue">
                  <i v-if="!isShow" class="el-input__icon el-icon-arrow-down" slot="suffix"></i>
                  <i v-if="isShow" class="el-input__icon el-icon-arrow-up" slot="suffix"></i>
            </el-input>
            <el-collapse-transition>
                <div v-if="isShow">
                        <div class="choiceDropMenu">
                            <el-row class="search">
                                <el-col :span="12">
                                    <el-input size="small" placeholder="请输入关键词" v-model="searchValue" suffix-icon="el-icon-search" @keydown.down.native="keyDownSearch" @keyup.enter.native="confirmSearch" @keydown.up.native="keyUpSearch"></el-input>
                                </el-col>
                            </el-row>
                            <template v-if="searchValue===''">
                                <el-row>
                                    <el-col :span="12">
                                        <ul class="menu-left">
                                            <li v-for="item in list" class="clearfix" :class="{ active: item.checked }" @click="checkCategory(item,$event)">
                                                {{item.text}}<i class="el-icon-caret-right"></i>
                                            </li>
                                        </ul>
                                    </el-col>
                                    <el-col :span="12">
                                        <ul class="menu-right">
                                            <li v-for="c in currentItem.list" :class="{ active: c.checked }" @click="checkField(c)">{{c.text}}</li>
                                        </ul>
                                    </el-col>
                                </el-row>
                            </template>
                            <template v-if="searchValue!==''">
                                <el-row>
                                    <ul class="search-menu">
                                        <li v-for="item in searchList" :class="{ active: item.checked }"  @click="checkField(item)">
                                            {{item.text}}
                                        </li>
                                    </ul>
                                </el-row>
                            </template>
                        </div>
                </div>
            </el-collapse-transition>
        </div>
</template>
<script>
export default {
    name:'ipKeywordChoice',
    props:{
        text:{type:String,default:''},
        keywordList:{type:Array,default(){return []}}
    },
    data(){
        return{
            isShow:false,
            searchValue:'',
            tempList:[],
            searchList:[],
            field:''
        }
    },
    mounted(){
        this.field = this.text;
    },
    computed:{
        currentItem(){
            for(let i=0;i<this.list.length;i++){
                if (this.list[i].checked){
                    return this.list[i]
                }
            }
        },
        list(){
            return this.keywordList
        }
    },
    watch:{
        searchValue(newValue,oldValue) {
            this.search(newValue);
        },
        text(newValue,oldValue){
            this.field = newValue;
        }
    },
    methods:{
        showChoiceBox(){
            this.isShow = true;
        },
        handleClose(){
            this.isShow = false;
        },
        checkCategory(item,event){
            for(let i=0;i<this.list.length;i++){
                this.list[i].checked = false
            }
            item.checked = true;
            // 保持焦点在input上,以使上下左右键生效
            let x = event.target;
            x = x.parentNode.parentNode.parentNode.parentNode.parentNode.parentNode;
            x.firstChild.children[0].focus();
        },
        search(searchValue){
            this.searchList = [];
            if(searchValue.trim() === ''){
                this.searchList = [];
                return
            }
            for(let i=0;i<this.list.length;i++){
                for(let j=0;j<this.list[i].list.length;j++){
                    if(this.list[i].list[j].text.indexOf(searchValue) !== -1){
                        this.searchList.push(this.list[i].list[j]);
                    }
                }
            }
        },
        keyDown() {
            if(this.searchList.length === 0){
                let moveList = this.list;
                if (this.tempList.length>0){
                    moveList = this.tempList;
                }
                let temp = 0;//指向下一个
                for(let i=0;i<moveList.length;i++){
                    if( moveList[i].checked){
                        if (i === moveList.length-1){
                            temp = 0;
                        }else{
                            temp = i + 1;
                        }
                    }
                    moveList[i].checked = false
                }
                moveList[temp].checked = true;
            }
        },
        keyUp() {
              if(this.searchList.length === 0){
                let moveList = this.list;
                if (this.tempList.length>0){
                    moveList = this.tempList;
                }
                let temp = 0;//指向上一个
                for(let i=0;i<moveList.length;i++){
                    if( moveList[i].checked){
                        if (i === 0){
                            temp = moveList.length - 1;
                        }else{
                            temp = i - 1;
                        }
                    }
                    moveList[i].checked = false
                }
                moveList[temp].checked = true;
              }
        },
        keyRight(){
             if(this.searchList.length === 0){
                this.tempList = [];
                for(let i=0;i<this.list.length;i++){
                    if( this.list[i].checked){
                        this.list[i].list[0].checked = true;
                        this.tempList = this.list[i].list
                    }
                }
             }
        },
        keyLeft(){
             if(this.searchList.length === 0){
                this.tempList = [];
                for(let i=0;i<this.list.length;i++){
                    for(let item=0;item<this.list[i].list.length;item++){
                        this.list[i].list[item].checked = false;
                    }
                }
             }
        },
        confirm() {
            if(this.tempList) {
                for (let i = 0; i < this.tempList.length; i++) {
                        if (this.tempList[i].checked){
                            this.field = this.tempList[i].text;
                            this.isShow = false;
                            this.$emit('selectField',{text:this.field,value:this.tempList[i].value, maxlength:this.tempList[i].maxlength});
                        }
                }
            }
        },
        checkField(c) {
            for (let i=0; i<this.currentItem.list.length;i++){
                this.currentItem.list[i].checked = false;
            }
            c.checked = true;
            this.field = c.text;
            this.isShow = false;
            this.$emit('selectField',{text:this.field,value:c.value, maxlength:c.maxlength});
        },
        keyDownSearch(){
            if (this.searchList.length > 0) {
                let temp = 0;//指向下一个
                for(let i=0;i<this.searchList.length;i++){
                    if( this.searchList[i].checked){
                        if (i === this.searchList.length-1){
                            temp = 0;
                        }else{
                            temp = i + 1;
                        }
                    }
                    this.searchList[i].checked = false;
                }
                this.searchList[temp].checked = true;
            }
        },
        keyUpSearch(){
            if (this.searchList.length > 0) {
                let temp = 0;//指向上一个
                for(let i=0;i<this.searchList.length;i++){
                    if(this.searchList[i].checked){
                        if (i === 0){
                            temp = this.searchList.length - 1;
                        }else{
                            temp = i - 1;
                        }
                    }
                    this.searchList[i].checked = false
                }
                this.searchList[temp].checked = true;
            }
        },
        confirmSearch(){
            if (this.searchList) {
                this.searchList.forEach(item=>{
                    if(item.checked){
                        this.field=item.text;
                        this.isShow = false;
                        this.searchValue = '';
                        this.searchList = [];
                        this.$emit('selectField',{text:this.field,value:item.value, maxlength:item.maxlength});
                    }
                })
            }
        },
        changeFieldValue(){
            this.$emit('changeField',this.field);
        }
    }
}
</script>
<style lang="scss" scoped>
.choiceComponent {
    position: relative;
    font-size: 14px;
    ul{
        margin: 0;
        padding: 0;
    }
    li{
        padding: 0;
        margin: 0;
        list-style: none;
    }
    .choiceDropMenu {
        width: 485px;
        position: absolute;
        top: 33px;
        left: 0;
        z-index: 99;
        background-color: #fff;
        border: solid 1px #e4e7ed;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
        .search {
            border-bottom: 1px solid #dcdfe6;
            padding: 10px;
        }
        .menu-left {
            border-right: 1px solid #dcdfe6;
            padding: 8px 0;
            height: 272px;
            box-sizing: border-box;
            overflow-y: auto;
            li {
                line-height: 32px;
                padding: 0 0 0 10px;
                cursor: pointer;
                i {
                    font-size: 12px;
                    float: right;
                    line-height: 32px;
                    margin-right: 10px;
                    color: #999;
                }
            }
            .active {
                background: #E2F0FF;
            }
        }
        .menu-right {
            padding: 8px 0;
            height: 272px;
            overflow-y: auto;
            box-sizing: border-box;
            li {
                line-height: 32px;
                padding: 0 0 0 10px;
                cursor: pointer;
            }
            .active {
                background: #ecf5ff;
            }
        }
        .search-menu{
            height: 272px;
            li{
                line-height: 32px;
                padding: 0 0 0 10px;
                cursor: pointer;
            }
            .active {
                background: #ecf5ff;
            }
        }
    }
}
</style>